import React from "react";
import { string } from "prop-types";

import { useAgentMatchData } from "../../redux/hooks/agentMatchHooks";
import AgentStats from "../AgentStats";
import * as S from "./styled";

const AgentCard = ({ className }) => {
  const agent = useAgentMatchData();
  const profileUrl = agent.uuid
    ? `${agent.profileUrl}&expertsApiUuid=${agent.uuid}`
    : agent.profileUrl;

  return (
    <div className={className} data-qa="agent-card">
      <S.AgentDescription
        agentImageSrc={agent.agentImageSrc}
        agentName={agent.agentName}
        agentTitle={agent.agentTitle}
        brokerage={agent.brokerage}
        isPro={agent.isPro}
        profileUrl={profileUrl}
      />
      <AgentStats
        medianSalesPrice={agent.medianSalesPrice}
        nearbyHomes={agent.nearbyHomes}
        recentHomesSold={agent.recentHomesSold}
        similarHomes={agent.similarHomes}
        soldHomesInUserBuilding={agent.soldHomesInUserBuilding}
        yearsExperience={agent.yearsExperience}
      />
    </div>
  );
};

AgentCard.propTypes = {
  className: string
};

AgentCard.defaultProps = {
  className: null
};

export default AgentCard;
